<h2 mat-dialog-title>Manage subgenre</h2>
<mat-dialog-content>
  <div class="d-flex flex-col">
    Name
    <input matInput [(ngModel)]="subgenreName" class="admin-input-field"/>
  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="onNoClick()">Cancel</button>
  <button matButton [mat-dialog-close]="subgenreName()">Save</button>
</mat-dialog-actions>
